import { render, staticRenderFns } from "./PortfolioDialog.vue?vue&type=template&id=bc854590&scoped=true"
import script from "./PortfolioDialog.vue?vue&type=script&lang=js"
export * from "./PortfolioDialog.vue?vue&type=script&lang=js"
import style0 from "./PortfolioDialog.vue?vue&type=style&index=0&id=bc854590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc854590",
  null
  
)

export default component.exports